// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CustomerOutlinedSvg from "@fishx/icons-svg/es/asn/CustomerOutlined";
import FishxIcon from '../components/FishxIcon';

var CustomerOutlined = function CustomerOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CustomerOutlinedSvg
  }));
};

CustomerOutlined.displayName = 'CustomerOutlined';
export default React.forwardRef(CustomerOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CustomerOutlined.js
// module id = 2360
// module chunks = 0